import React, { useMemo, useRef } from "react";
import { UncontrolledTooltip } from "reactstrap";

const genId = () => `readable-${Math.random().toString(36).slice(2, 11)}`;

/**
 * Reusable cell content for admin list tables: truncates long text with ellipsis
 * and shows full content in a tooltip on hover. Keeps rows readable on small screens.
 */
const ReadableCell = ({ children, title, className = "", style = {}, as: Tag = "span" }) => {
  const idRef = useRef(null);
  if (!idRef.current) idRef.current = genId();
  const id = idRef.current;
  const text = useMemo(() => {
    if (typeof children === "string") return children;
    if (children == null) return "";
    if (typeof children === "number") return String(children);
    return null;
  }, [children]);
  const tooltipContent = title != null ? title : text;

  return (
    <>
      <Tag
        id={id}
        className={`readable-cell text-truncate d-inline-block ${className}`}
        style={style}
        title={tooltipContent || undefined}
      >
        {children}
      </Tag>
      {tooltipContent && (
        <UncontrolledTooltip placement="top" target={id}>
          {tooltipContent}
        </UncontrolledTooltip>
      )}
    </>
  );
};

export default ReadableCell;
